import React from "react";

const Unauthorized = () => {
  return (
    <div className="text-center mt-20 text-red-500 text-xl">
      You do not have permission to view this page.
    </div>
  );
};

export default Unauthorized;
